// @ts-nocheck
import React from 'react';
import { Col, DatePicker, Form, Input, InputNumber, Row, Select } from 'antd';
import { NumberInput } from 'shared_components/pattern_input';
import dayjs from "dayjs";

import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"

dayjs.extend(weekday)
dayjs.extend(localeData)

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function ReportParametersPanel(props) {
    const { dateRangeInput, dateRangeValue, reportParams, section } = props
    console.log('report param props', props)

    const dateDefaultValues = (value, type) => {
        const formatType = type === 'date' ? 'MM-DD-YYYY' : type === 'datetime' ? 'MM-DD-YYYY HH:mm' : 'MM-DD-YYYY';

        if(value === '1st Day'){
            return { value: dayjs().startOf('month'), type: formatType}
        }

        if(value === 'Last Day'){
            return { value: dayjs(), type: formatType}
        }

        if(value === 'NOW'){
            return { value: dayjs(), type: formatType}
        }

        if(value === 'NOW @ 0H'){
            return { value: dayjs().startOf('month'), type: formatType}
        }

        return { value: dayjs(), type: formatType}
    }

    const dateRangeField = () => {
        const fromDate = dateDefaultValues(dateRangeValue.startDefaultValue, dateRangeValue.startType)
        if(dateRangeInput) {
            const disableField = dateRangeValue.startEnable === true && dateRangeValue.endEnable === true ? false : true
            console.log('disableField', disableField)
            
            return(
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label={`${dateRangeValue.startLabel} - ${dateRangeValue.endLabel}`}
                            name="dateRange"
                            initialValue={[fromDate.value, dayjs()]}
                        >
                            <RangePicker showTime style={{ width: '100%' }} format={fromDate.type} disabled={disableField} />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    }

    const paramField = (param) => {
        if (param.type === 'number') {
            return <NumberInput style={{ width: '100%' }} disabled={ !param.enable } />;
        }

        if (param.type === 'decimal') {
            return <InputNumber stringMode style={{ width: '100%' }} disabled={ !param.enable } />;
        }

        if(param.type === 'text'){
            return <Input style={{ width: '100%' }} disabled={ !param.enable } />
        }

        if(param.type === 'date'){
            const dateInput = dateDefaultValues(param.defaultvalue, param.type)
            return <DatePicker style={{ width: '100%' }} defaultValue={dateInput.value} format={dateInput.type} disabled={ !param.enable } />
        }

        if(param.type === 'datetime'){
            const dateInput = dateDefaultValues(param.defaultvalue, param.type)
            return <DatePicker showTime style={{ width: '100%' }} defaultValue={dateInput.value} format={dateInput.type} disabled={ !param.enable } />
        }

        if(param.type === 'list'){
            const listOptions = param.lov.map((items)=> {
                return(
                    <Option key={items} value={items}>{items}</Option>
                )
            })

            return(
                <Select disabled={ !param.enable } >
                    { listOptions }
                </Select>
            )
        }

        return <Input style={{ width: '100%' }} disabled={ !param.enable } />
    }

    const generateParams = reportParams 
    ?   reportParams.map(item => {
            let getDefaultValue;
            let checkDefaultValue = false;
            let getParamField = '';

            if(item.defaultvalue.substring(0, 1) === '<' && item.defaultvalue.substring(item.defaultvalue.length -1) === '>'){
                checkDefaultValue = true;
                getParamField = item.defaultvalue.substring(1, item.defaultvalue.length -1)

                Object.entries(section[0]).filter(([key, value]) => {
                    if(key === getParamField){
                        getDefaultValue = value
                    }
                })
            }else{
                checkDefaultValue = false;
            }

            return(
                <div>
                    {(item.type === 'date' ? true : item.type === 'datetime' ? true : false) === true
                    ?   <Row>
                            <Col span={24}>
                                <Form.Item
                                    label={item.label}
                                    name={item.key}
                                >
                                    {paramField(item)}
                                </Form.Item>
                            </Col>
                        </Row>
                        
                    :   <Row>
                        <Col span={24}>
                            <Form.Item
                                label={item.label}
                                name={item.key}
                                initialValue={checkDefaultValue ? getDefaultValue : item.defaultvalue}
                                hidden={!item.show}
                            >
                                {paramField(item)}
                            </Form.Item>
                        </Col>
                        </Row>
                    }
                </div>
            )
        })
    : null;

    return(
        <div>
            {dateRangeInput 
                ? (dateRangeField())
                : <></>
            }
            {generateParams}
        </div>
    )
}